import $ from 'jquery';

if (typeof $.type === 'undefined') {
    $.type = function(obj) {
        return Object.prototype.toString.call(obj).slice(8, -1).toLowerCase();
    };
}


Drupal.behaviors.boxCalcMargin = {
  attach: function (context) {
    $(document).ready( function () {
      function checkWidth() {
        let $textBox = $('.text-box');
        let $textBoxFull = $('.text-box-full');
        $( $textBox ).each(function() {
          var windowSize = window.innerWidth;
          if (windowSize <= 980) {
            let halfTextBoxHeight = $(this).height() / 1 * 0.66;
            $(this).closest('.section').css("margin-bottom", halfTextBoxHeight + 30);
          } 

          else if (windowSize <= 1080) {
            let halfTextBoxHeight = $(this).height() / 1 * 0.66;
            $(this).closest('.section').css("margin-bottom", halfTextBoxHeight + 60);
          } 

          else if (windowSize > 1200) {
            //Calculate half the height of each element with class box-margin
            let halfTextBoxHeight = $(this).height() / 2;

            //Add half of the text box height to each closest section + the the main margin bottom for sections(60px)
            $(this).closest('.section').css("margin-bottom", halfTextBoxHeight + 60);
          }  
        });

        $( $textBoxFull ).each(function() {
          var windowSize = window.innerWidth;
          if (windowSize <= 980) {
            //Calculate full height
            let fullTextBoxHeight = $(this).height() / 1 * 0.66;
            $(this).closest('.section').css("margin-bottom", fullTextBoxHeight + 30); 
          } 

          else if (windowSize <= 1080) {
            //Calculate full height
            let fullTextBoxHeight = $(this).height() / 1 * 0.66;
            $(this).closest('.section').css("margin-bottom", fullTextBoxHeight + 60); 
          } 

          else if (windowSize > 1200) {
            //Calculate full height
            let fullTextBoxHeight = $(this).height();
      
            $(this).closest('.single-push__wrapper').css("height", fullTextBoxHeight + 200);
          }
        });
      }
      checkWidth();

      const debounce = (callback, delay = 100) => {
        let timeoutId;
        return (...args) => {
          clearTimeout(timeoutId);
          timeoutId = setTimeout(() => {
            callback(...args);
          }, delay);
        };
      };
  
      const debounceCheck = debounce(checkWidth, 100);
  
      var cachedWidth = window.innerWidth;
      $(window).resize(function(){
        var newWidth = window.innerWidth;
        if(newWidth !== cachedWidth){
          debounceCheck();
          cachedWidth = newWidth;
        }
      });
    });
  }
}